import Api from "../apis/public-api";
import wxsdk from "weixin-js-sdk";
import MaintenanceApi from "@/apis/maintenance-api.js";

/**
 * 需要注册的 Api
 */
var jsApiList = [
  "chooseWXPay",
  "hideMenuItems",
  "chooseImage",
  "previewImage.",
  "uploadImage",
  "downloadImage",
  "hideAllNonBaseMenuItem",
  "showAllNonBaseMenuItem",
  "onMenuShareQQ",
  "updateAppMessageShareData",
  "onMenuShareAppMessage",
  "onMenuShareTimeline",
  "startRecord",
  "stopRecord",
  "onVoiceRecordEnd",
  "playVoice",
  "pauseVoice",
  "stopVoice",
  "onVoicePlayEnd",
  "uploadVoice",
  "downloadVoice",
  "translateVoice",
  "scanQRCode",
  "openEnterpriseContact",
];

/**
 * 根据code获取用户信息
 * @param {*} url
 * @param {*} path
 */
const wxConfig = (data) => {
  Api.getConfig({
    url: window.location.href,
    api: jsApiList,
    debug: 1,
    beta: 1,
  }).then((res) => {
    if (res.code == 0) {
      wxsdk.config({
        beta: true,
        debug: false,
        appId: res.data.appId,
        timestamp: res.data.timestamp,
        nonceStr: res.data.nonceStr,
        signature: res.data.signature,
        jsApiList: res.data.jsApiList,
      });
      wxsdk.ready(() => {
        console.log("微信sdk成功", data);
        // wxShare();
        window.sessionStorage.setItem("wxsdkReady", "true");
      });
      wxsdk.error((res) => {
        console.log("微信sdk失败", res);
      });
    }
  });
};

const optionShare = (id) => {
  if (!id) return;
  // if (Vue.prototype.browser.wx == 0) {
  //   return;
  // }
  MaintenanceApi.getShareApi({
    scheme_id: id,
  }).then((res) => {
    if (res.code == 0) {
      // eslint-disable-next-line no-undef
      window.sessionStorage.setItem("OILSHARE", JSON.stringify(res.data)); // 缓存版本分享数据
      window.sessionStorage.setItem("OILVERSION", id); // 缓存版本id
      document.title = res.data.name;
      wxConfig(Object.assign(res, { scheme_id: id })); // 配置微信jssdk
    } else {
      console.error("数据统计失败", res.message);
    }
  });
};

const wxShare = () => {
  let url = window.location.href;
  console.log("分享地址", url);
  // if (["/detail", "/home"].indexOf(window.location.pathname) > -1) {
  //   url = window.location.href;
  // }
  wxsdk.ready(() => {
    const shareInfo = JSON.parse(window.sessionStorage.getItem("OILSHARE"));
    console.log("配置成功分享", shareInfo);
    window.sessionStorage.setItem("wxsdkReady", "true");
    // 分享给微信好友
    wxsdk.showAllNonBaseMenuItem();
    wxsdk.updateAppMessageShareData({
      title: shareInfo.title,
      desc: shareInfo.describe,
      link: url,
      imgUrl: shareInfo.url,
    });
    // 分享到朋友圈
    wxsdk.updateTimelineShareData({
      title: shareInfo.title,
      link: url,
      imgUrl: shareInfo.url,
    });
  });
};

export { wxConfig, optionShare, wxShare };
